export default {
  emits: ['update:modelValue'],

  props: {
    modelValue: {type: [String, Number, Date], default: ''},
    name: {type: String, default: ''},
  },

  data: function () {
    return {
      value: this.modelValue,
    }
  },

  watch: {
    modelValue: {
      handler(val) {
        this.value = val;
      },
      deep: true
    },
    value: {
      handler(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
}
